<template>
  <v-card>
    <v-card-text>
      <v-subheader>
        <v-icon>face</v-icon>&nbsp;General
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Firstname</span>
              <span style="font-size: 16px">{{ profile.first_name }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Lastname</span>
              <span style="font-size: 16px">{{ profile.last_name }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Birthdate</span>
              <span style="font-size: 16px">{{ profile.birthdate }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Alias</span>
              <span style="font-size: 16px">{{ profile.alias }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md9>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Email</span>
              <span style="font-size: 16px">{{ profile.email }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Language</span>
              <span style="font-size: 16px">{{ profile.language }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Stripe customer id</span>
              <span style="font-size: 16px">{{ profile.customer_id }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Front id</span>
              <span style="font-size: 16px">{{ profile.front_id }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Profile creation date</span>
              <span style="font-size: 16px">{{ created }}</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md3>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Status</span>
              <span
                v-if="profile.disabled"
                style="font-size: 16px"
                class="red--text font-weight-medium"
              >Unsuscribed</span>
              <span v-else style="font-size: 16px" class="green--text font-weight-medium">Active</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>phone</v-icon>&nbsp;Phone
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Phone number</span>
              <span style="font-size: 16px">{{ profile.phone_number }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">National phone number</span>
              <span style="font-size: 16px">{{ profile.phone_number_national }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Phone number country</span>
              <span style="font-size: 16px">{{ profile.phone_number_region }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>business</v-icon>&nbsp;Business and Subscription
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Business ID</span>
              <span style="font-size: 16px">{{ profile.business }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Business code</span>
              <span style="font-size: 16px">{{ profile.business_code }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Plan ID</span>
              <span style="font-size: 16px">{{ profile.current_subscription }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Subscription ID</span>
              <span style="font-size: 16px">{{ profile.subscription_id }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>attach_money</v-icon>&nbsp;Invoice information
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Invoice Country</span>
              <span style="font-size: 16px">{{ profile.invoice_country }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 v6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">VAT number</span>
              <span style="font-size: 16px">{{ profile.vat_number }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>smartphone</v-icon>&nbsp;Device
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Device ID</span>
              <span style="font-size: 16px">{{ profile.device_id }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs12 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Device OS</span>
              <span style="font-size: 16px">{{ profile.device_os }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>cloud</v-icon>&nbsp;API
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">API access</span>
              <span style="font-size: 16px">{{ profile.api_access }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md6>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">API access level</span>
              <span style="font-size: 16px">{{ profile.api_access_level }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <v-subheader>
        <v-icon>security</v-icon>&nbsp;Authorization
      </v-subheader>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">User type</span>
              <span style="font-size: 16px">{{ profile.user_type }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Website access level</span>
              <span style="font-size: 16px">{{ profile.access_level }}&nbsp;</span>
            </v-layout>
          </v-flex>

          <v-flex xs6 md4>
            <v-layout column ma-0>
              <span style="color: rgba(0, 0, 0, 0.54)">Admin</span>
              <span style="font-size: 16px">{{ profile.is_admin }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
//import fb from "@/firebase";
//import { mapMutations } from "vuex";

export default {
  name: "ProfileInfo",
  components: {},
  props: {
    profile: Object
  },
  data: () => ({
    loading: false,
    created: ""
  }),
  methods: {},
  mounted() {
    if (this.profile && this.profile.created) {
      if (this.profile.created < 1000000000000) {
        this.created = new Date(this.profile.created * 1000)
          .toISOString()
          .substr(0, 10);
      } else {
        this.created = new Date(this.profile.created)
          .toISOString()
          .substr(0, 10);
      }
    }
  },
  watch: {}
};
</script>
